// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#606266","menuActiveText":"#409eff","subMenuActiveText":"#f4f4f5","menuBg":"#fff","menuHover":"#f0f9ea","subMenuBg":"#fff","subMenuHover":"#fff","sideBarWidth":"0.6rem"};